<template>
  <div class="relatorio-filtro">
    <el-form :model="filtros" size="small">
      <el-row :gutter="20" align="bottom">
        <!-- Data da Solicitação -->
        <el-col :span="6">
          <el-form-item label="Data da Solicitação">
            <el-date-picker
              v-model="filtros.dataSolicitacao"
              type="daterange"
              range-separator="|"
              start-placeholder="De"
              end-placeholder="Até"
              align="right"
              format="dd/MM/yyyy"
              size="small"
              class="w-100"
            />
          </el-form-item>
        </el-col>

        <!-- Origem -->
        <el-col :span="6">
          <el-form-item label="Origem">
            <el-select
              class="d-inline-block w-100"
              size="small"
              v-model="filtros.origem"
              multiple
              placeholder="Selecione a origem"
              filterable
              collapse-tags
            >
              <el-option
                v-for="origem in opcoesOrigem"
                :key="origem.value"
                :label="origem.label"
                :value="origem.value"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <!-- Status -->
        <el-col :span="6">
          <el-form-item label="Status">
            <el-select
              class="d-inline-block w-100"
              size="small"
              v-model="filtros.status"
              placeholder="Selecione o status"
            >
              <el-option
                v-for="status in opcoesStatus"
                :key="status.value"
                :label="status.label"
                :value="status.value"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <!-- Botões -->
        <el-col :span="6" class="d-flex align-items-end hide-label">
          <el-form-item label="pesquisar">
            <div class="button-container">
              <el-button
                size="small"
                type="primary"
                icon="el-icon-search"
                @click="pesquisar"
              >
                Pesquisar
              </el-button>
              <el-button
                size="small"
                icon="el-icon-brush"
                @click="limpar"
                class="ml-2"
              >
                Limpar
              </el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
const statusArquivo = {
  0: "Aguardando", // warning
  1: "Processando", // primary
  2: "Finalizado", // success
  3: "Erro", // danger
};

export default {
  data() {
    return {
      filtros: {
        dataSolicitacao: null,
        origem: [],
        status: null,
      },
      opcoesOrigem: [],
      opcoesStatus: Object.entries(statusArquivo).map(([key, label]) => ({
        value: Number(key),
        label,
      })),
      loadOrigem: false,
    };
  },
  methods: {
    pesquisar() {
      const filtrosEmitidos = {
        origem: this.filtros.origem,
        dataSolicitacaoInicio: this.filtros.dataSolicitacao
          ? this.filtros.dataSolicitacao[0]
          : null,
        dataSolicitacaoFinal: this.filtros.dataSolicitacao
          ? this.filtros.dataSolicitacao[1]
          : null,
        status: this.filtros.status,
      };

      this.$emit("atualizarLista", filtrosEmitidos);
    },
    limpar() {
      this.filtros = {
        dataSolicitacao: null,
        origem: [],
        status: null,
      };
      this.$emit("atualizarLista", this.filtros);
    },
    formatarLabel(camelCaseText) {
      return camelCaseText
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2");
    },
    async listarTiposRelatoriosOrigem() {
      this.loadOrigem = true;

      const { data } = await this.axios.get(this.$urls.RELATORIO_TIPO_ORIGEM);

      this.opcoesOrigem = Object.keys(data).map((key) => ({
        label: this.formatarLabel(key),
        value: data[key],
      }));

      this.loadOrigem = false;
    },
  },
  mounted() {
    this.listarTiposRelatoriosOrigem();
  },
};
</script>

<style scoped>
.relatorio-filtro {
  margin-bottom: 20px;
}
.ml-2 {
  margin-left: 10px;
}
.d-flex {
  display: flex;
}
.align-items-end {
  align-items: flex-end;
}
.button-container {
  display: flex;
  width: 100%;
  justify-content: flex-start;
}
</style>
<style>
.hide-label .el-form-item__label {
  visibility: hidden;
}
</style>
